/*
 * @Description: 
 * @Autor: pangting
 * @Date: 2023-12-06 08:32:06
 * @LastEditors: pangting
 * @LastEditTime: 2023-12-06 08:42:11
 */
export default {
    name: 'vxeGridCellExpand',
    functional: true,
    props: {
        row: Object,
        render: Function,
    },
    render: (h, ctx) => {
        return ctx.props.render(h, ctx.props.row);
    }
};